import React from 'react'

import { formatSurchargeValue } from '../../utils/formatSurcharge'

import {
  Box,
  Text,
  FontFamily,
  FontWeight,
  JustifyContent,
  FlexDirection,
  Display,
  DisplayPosition,
} from '@gousto-internal/citrus-react'
import { SoldOutOverlay } from '../SoldOutOverlay'
import { getOverlayColor } from '../../utils/getOverlayColor'
import { Recipe } from '@library/menu-service'

type RecipeTilePurchaseInfoProps = {
  isOutOfStock: boolean
  recipe: Recipe
}

export const RecipeTilePurchaseInfo: React.FC<RecipeTilePurchaseInfoProps> = ({
  isOutOfStock,
  recipe,
}) => {
  const formattedSurcharge = formatSurchargeValue((recipe.surcharge?.pricePerPortion ?? 0) / 100)

  const justifyContent = !!formattedSurcharge ? JustifyContent.SpaceBetween : JustifyContent.FlexEnd

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} justifyContent={justifyContent}>
      {Boolean(formattedSurcharge) && (
        <Box position={DisplayPosition.Relative} style={{ paddingTop: '8px' }}>
          <SoldOutOverlay backgroundColor={getOverlayColor(recipe)} isOutOfStock={isOutOfStock} />
          <Text size={2} fontFamily={FontFamily.Book} fontWeight={FontWeight.Normal}>
            {formattedSurcharge} a serving
          </Text>
        </Box>
      )}
    </Box>
  )
}
